module.exports = __webpack_public_path__ + "img/logo.dbe368a0.png";